/* eslint-disable */
import React from 'react'
import { Link } from 'react-router-dom'
import AboutProvider from './AboutProvider';
import ContactInfo from './ContactInfo';
import RecentProjects from './RecentProjects';
import Reviews from './Reviews';
import ServiceLists from './ServiceLists';
import Complains from './Complains';
import Conversation from './Conversation';


const ProfileDetail2 = ({ companyData: company }) => {
    // const ref = useRef(null);

    const handleClick = (val) => {
        document.getElementById(val)?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <>
            {/*Nav Section Start*/}
            <div className="sf-page-scroll-wrap sf-page-scroll-wrap2">
                <div className="container">
                    <div className="sf-page-scroll-nav clearfix">
                        <ul className="clearfix fw-700">
                            <li>
                                <Link className='text-decoration-none' onClick={() => handleClick("aon-provider-about")} >About</Link>
                            </li>
                            <li>
                                <Link className='text-decoration-none' onClick={() => handleClick("aon-provider-services")} >Services</Link>
                            </li>
                            <li>
                                <Link className='text-decoration-none' onClick={() => handleClick("aon-provider-coInfo")}>Contact Info</Link>
                            </li>
                            <li>
                                <Link className='text-decoration-none' onClick={() => handleClick("aon-provider-conversation")}>Conversation</Link>
                            </li>

                            <li>
                                <Link className='text-decoration-none' onClick={() => handleClick("aon-provider-Req-quote")}>Request A Quote</Link>
                            </li>
                            <li>
                                <Link className='text-decoration-none' onClick={() => handleClick("aon-provider-coRep")}>Reputation</Link>
                            </li>
                            <li>
                                <Link className='text-decoration-none' onClick={() => handleClick("aon-provider-review")}>Reviews</Link>
                            </li>
                            <li>
                                <Link className='text-decoration-none' onClick={() => handleClick("aon-provider-complaints")}>Suggestions and Complaints</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {/*Nav Section End*/}
            {/*Service List Start*/}

            <AboutProvider company={company} />
            <div className="container" >
                <div
                    id="aon-provider-services"
                    className="sf-provi-service-box m-b50 sf-provi-fullBox pt-5"
                >
                    <h3 className="sf-provi-title text-drk-primary s-22 fw-800">
                        Services
                    </h3>
                    <div className="sf-divider-line" />
                    {company?.services && company.services.length > 0 ?
                        (<strong className="m-2">
                            Company offering some special price services{" "}
                        </strong>) : <></>
                    }
                    {company?.services && company.services.length > 0 ? (
                        company.services.map((item) => (
                            <ServiceLists key={`service_${item.id}`} company={company} serviceInfo={item} />
                        ))
                    ) : (
                        <div className="row justify-content-center">
                            <div className="col-lg-4 col-md-4">
                                <div className="loader">
                                    <div className="loader-text">No Service available...</div>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
            {/* <ServiceList0 company={company} /> */}


            <RecentProjects company={company} />
            {/* <RequestQuote company={company} /> */}
            <ContactInfo company={company} />
            <Conversation company={company} />
            {/* <ProfileFaq company={company} /> */}
            <Complains company={company} />
            <Reviews company={company} />


        </>

    )
}

export default ProfileDetail2